var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('BarChart',{staticStyle:{"height":"16px"},attrs:{"list":_vm.chartList,"hide-labels":""}}),_c('span',{staticClass:"position-absolute w-100 h-100 d-flex align-items-center justify-content-center text-white duration-text"},[_vm._v(" "+_vm._s(_vm.leftDuration)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }